module.exports = __webpack_public_path__ + "img/speaker-ShotaArveladze-img.af96a624.png";